import { useEffect, useState } from "react";
import { Box, Button, Grid, Alert, Stepper, Step, StepButton } from "@mui/material";
import { Error } from "@mui/icons-material";
import { CopyToClipboard } from "react-copy-to-clipboard/src";
import { t } from "i18next";
import api from "../../../../../../helpers/api/Api";
import ApiUrls from "../../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../../helpers/api/errors/ShowStatus";
import LoadingProgress from "../../../../../../components/LoadingProgress";
import "./systemManaged.css";

function SystemManaged({ domain }) {
  const steps = [
    'مرحله یک',
    'مرحله دو',
    'مرحله سه',
  ];
  const [data, setData] = useState({
    result: [],
    activeStep: -1,
    status: ""
  });
  const { result, activeStep, status } = data;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
  const [didBack, setDidBack] = useState(false);

  useEffect(() => {
    if (domain) {
      getData();
    }
  }, [domain]);

  const getData = (step = false) => {
    setLoading(true);
    setError(null);

    const postFormData = new FormData();
    postFormData.append("uid", domain.id);
    if (step && !didBack) {
      postFormData.append("step", step);
    }

    api.post(ApiUrls.domain.certSysData, postFormData)
      .then((response) => {
        setLoading(false);
        setResultToData(response.data);
      })
      .catch((error) => {
        setLoading(false);
        showStatus("cert_1_error");
      });
  }

  const setResultToData = (response) => {
    switch (response.step) {
      case 1:
        if (response?.status === "success") {
          setData({
            result: response.result,
            activeStep: 0,
            status: "success"
          });
        } else {
          showStatus("general_error");
        }
        break;
      case 2:
        setData({
          result: response.result,
          activeStep: 1,
          status: "error"
        });
        setError("آدرس‌های مرحله یک هنوز به DNS اضافه نشده‌اند، در صورتی که قبلا آن‌ها را اضافه کرده‌اید لطفا کمی صبر کنید. \nدر غیر این صورت به مرحله یک برگشته و دوباره امتحان کنید.");
        break;
      case 3:
        setData({
          result: response.result && response.result[0],
          activeStep: 1,
          status: "success"
        });
        break;
      case 4:
        setData({
          result: t("domain.certificate_s4"),
          activeStep: 2,
          status: "success"
        });
        break;
    }
  }

  const goStepOne = () => {
    if (activeStep !== 0) {
      setDidBack(true);
      getData(1);
    }
  }

  const handleNext = () => {
    getData(99);
  };

  const onCopy = (text) => {
    showStatus("copied");
  }

  return (
    <Grid container spacing={2} ml={0}>
      <Grid item md={12} xs={12} mt={3}
            className="d-flex flex-column justify-content-center align-items-center w-100"
      >
        {loading ?
          <LoadingProgress color="info" />
          :
          <>
            <Stepper nonLinear activeStep={activeStep}>
              {steps.map((label, i) => (
                <Step key={`step-${i}`} >
                  <StepButton
                    color="inherit"
                    className={i !== 0 ? "step-button" : ""}
                    {...i === 0 && { onClick: goStepOne }}
                  >
                    {label}
                  </StepButton>
                </Step>
              ))}
            </Stepper>

            <Box sx={{ display: 'flex', flexDirection: 'column', pt: 2 }} className="stepper-box">
              {activeStep === 0 &&
                <div className="stepper mt-2">
                  <h6 className="mb-4">لطفا در DNS خود موارد زیر را وارد کنید:</h6>
                  {result && result.map((d, i) => {
                    return (
                      <div className="d-flex step-1 align-items-center mb-md-0 mb-2" key={`step1-${i}`} >
                        <div className="step-1-domain">{d}</div>

                        <CopyToClipboard text={d} onCopy={onCopy}>
                          <Button onClick={() => onCopy(d)}>
                            کپی
                          </Button>
                        </CopyToClipboard>
                      </div>
                    )
                  })}
                </div>
              }

              {activeStep === 1 && status === "error" &&
                <div className="stepper mt-2 pe-md-5 pe-0">
                  {result && result.map((r, i) => {
                    return (
                      <div className="step-2 mb-2" key={`step2-${i}`} >
                        <div className="step-2-domain"> <b>دامنه:</b>{" "}{r.domain} </div>
                        <div className="step-2-message text-danger"> <Error color="error" />{" "}{r.message} </div>
                      </div>
                    )
                  })}
                </div>
              }

              {activeStep === 1 && status === "success" &&
                <div className="d-flex justify-content-center">
                  <Grid item md={6} xs={12} mt={3}>
                    <Alert severity="info">
                      {t("domain.certificate_load")}
                    </Alert>
                  </Grid>
                </div>
              }

              {activeStep === 2 && status === "success" &&
                <div className="d-flex justify-content-center">
                  <Grid item md={6} xs={12} mt={3}>
                    <Alert severity="info">
                      {result}
                    </Alert>
                  </Grid>
                </div>
              }

              {error &&
                <Grid item md={12} mt={3}>
                  <Alert severity="error">
                    {error}
                  </Alert>
                </Grid>
              }

              {activeStep === 0 &&
                <div className="d-flex w-100 justify-content-center mt-5">
                  <Button variant={"outlined"} onClick={handleNext}>
                    انجام شد
                  </Button>
                </div>
              }

            </Box>
          </>
        }
      </Grid>
    </Grid>
  );
}

export default SystemManaged;